import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { IconBundleBlueprint } from '@backstage/plugin-app-react';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import BatteryChargingFullIcon from '@material-ui/icons/BatteryChargingFull';
import BookIcon from '@material-ui/icons/Book';
import BuildIcon from '@material-ui/icons/Build';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CloudIcon from '@material-ui/icons/Cloud';
import EcoIcon from '@material-ui/icons/Eco';
import FlagOutlinedIcon from '@material-ui/icons/FlagOutlined';
import HomeIcon from '@material-ui/icons/Home';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import LinkIcon from '@material-ui/icons/Link';
import MenuIcon from '@material-ui/icons/Menu';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import PaletteIcon from '@material-ui/icons/Palette';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import { RadixIcon } from '@internal/backstage-plugin-radix';
import { VariaIcon } from './VariaIcon';

const appIcons = IconBundleBlueprint.make({
  name: 'app-icons',
  params: {
    icons: {
      addCircleOutline: <AddCircleOutlineIcon />,
      batteryChargingFull: <BatteryChargingFullIcon />,
      book: <BookIcon />,
      build: <BuildIcon />,
      checkBox: <CheckBoxIcon />,
      cloud: <CloudIcon />,
      eco: <EcoIcon />,
      flagOutlined: <FlagOutlinedIcon />,
      home: <HomeIcon />,
      infoOutlined: <InfoOutlinedIcon />,
      libraryBooks: <LibraryBooksIcon />,
      link: <LinkIcon />,
      menu: <MenuIcon />,
      menuBook: <MenuBookIcon />,
      palette: <PaletteIcon />,
      radix: <RadixIcon />,
      trackChanges: <TrackChangesIcon />,
      varia: <VariaIcon />,
      verifiedUser: <VerifiedUserIcon />,
    },
  },
});

export const appIconsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [appIcons],
});
